<div class="overlay">
  <!--  <div class="spinner spinner1">-->
  <!--    <div></div>-->
  <!--    <div></div>-->
  <!--    <div></div>-->
  <!--    <div></div>-->
  <!--  </div>-->

  <div class="spinner rainbow-spinner"></div>
</div>
<!-- <div class="vertical-centered-box">
  <div class="content">
    <div class="loader-circle"></div>
    <div class="loader-line-mask one">
      <div class="loader-line"></div>
    </div>
    <div class="loader-line-mask two">
      <div class="loader-line"></div>
    </div>
    <div class="loader-line-mask three">
      <div class="loader-line"></div>
    </div>
    <div class="loader-line-mask four">
      <div class="loader-line"></div>
    </div>
    <div class="loader-line-mask five">
      <div class="loader-line"></div>
    </div>
    <div class="loader-line-mask six">
      <div class="loader-line"></div>
    </div>
    <div class="loader-line-mask seven">
      <div class="loader-line"></div>
    </div>
    <div class="loader-line-mask eight">
      <div class="loader-line"></div>
    </div>
    <div class="loader-line-mask nine">
      <div class="loader-line"></div>
    </div>
  </div>
</div> -->
